import { AppState } from '../../../store/App.reducer'
import { Auth, LoginResponse } from '../interfaces/auth.interfaces'

export const selectAuth = (state: AppState): Auth | null => state.auth.user
export const selectTokenInfo = (state: AppState): LoginResponse | null => state.auth.tokenInfo
export const selectEmailTemp = (state: AppState): Auth['email'] | null => state.auth.emailRecoveryAcc
